import { defineStore } from "pinia";
import { filters } from "@/store/filters";
import dayjs from "dayjs";
import { getShipments } from "@/lib/api";
import { parseResponseAsShipments } from "@/lib/parseResponseAsShipments";
import { dateComparator } from "@/lib/utilities";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export const unconfirmedBookings = defineStore("unconfirmedBookings", {
  state: () => ({
    allUnconfirmedBookings: [],
    unconfirmedBookingsData: [],
    lastPage: null,
    totalCount: "",
    unconfirmedBookingsError: null,
    showSpinner: true,
    paginationToken: 1,
    shipments: [],
    errors: []
  }),
  actions: {
    async getUnconfirmedBookings() {
      const queryParams = {
        departingFromDateUtc: dayjs().utc().format("YYYY-MM-DD"),
        departingToDateUtc: dayjs().utc().add(3, "month").format("YYYY-MM-DD"),
        page: this.paginationToken,
        limit: 25,
        sort: "etdUtcAtPortOfLoading:asc",
        ...filters().getGlobalFilters,
        taskCode: "0000000000011",
        statusCode: "1"
      };

      this.showSpinner = true;

      try {
        this.shipments = [];
        const firstResponse = await getShipments(queryParams, "shipments, tasks");
        let nextPage = Number(firstResponse.headers["next-page"]);

        this.shipments.push(...firstResponse.data);

        if (nextPage) {
          while (nextPage) {
            queryParams.page = nextPage;
            const res = await getShipments(queryParams, "shipments, tasks");
            this.shipments.push(...res.data);
            nextPage = res.headers["next-page"];
          }
        }
      } catch (e) {
        this.errors.push(e.status);
      } finally {
        queryParams.page = "1";
        queryParams.statusCode = "2";
      }

      try {
        const secondResponse = await getShipments(queryParams, "shipments, tasks");
        let nextPage = Number(secondResponse.headers["next-page"]);

        this.shipments.push(...secondResponse.data);

        if (nextPage) {
          while (nextPage) {
            queryParams.page = nextPage;
            const res = await getShipments(queryParams, "shipments, tasks");
            this.shipments.push(...res.data);
            nextPage = res.headers["next-page"];
          }
        }
      } catch (e) {
        this.errors.push(e.status);
      }

      if (this.shipments.length > 0) {
        this.allUnconfirmedBookings = parseResponseAsShipments(
          this.shipments.sort((a, b) => dateComparator(a.etdUtcAtPlaceOfReceipt, b.etdUtcAtPlaceOfReceipt, null))
        );
        this.unconfirmedBookingsData = this.allUnconfirmedBookings.slice(0, 25);
        this.totalCount = this.allUnconfirmedBookings.length;
        this.lastPage = Math.ceil(this.allUnconfirmedBookings.length / 25);
      } else if (this.shipments.length === 0 && this.errors?.some((error) => error === 404)) {
        this.unconfirmedBookingsData = [];
        this.totalCount = 0;
        this.lastPage = 0;
        this.unconfirmedBookingsError = false;
      } else {
        this.unconfirmedBookingsError = true;
      }

      this.showSpinner = false;
    },
    updatePaginationToken(page) {
      this.paginationToken = page;
      const startPage = (page - 1) * 25;
      const endPage = startPage + 25;
      this.unconfirmedBookingsData = this.allUnconfirmedBookings.slice(startPage, endPage);
    }
  }
});
